import { InjectionToken } from '@angular/core';
import { AelCifradoService } from 'ael-afiliacion-cifrado-utility';

export const AEL_CIFRADO_SERVICE_TOKEN = new InjectionToken<AelCifradoService>('AelCifradoService');